export const UPDATE_BASE = 'UPDATE_BASE';
export const NOTIFY = 'NOTIFY';
export const AFTABE_SHAFA = 'AFTABE_SHAFA';

export const updateBase = props => {
    return {
        type: UPDATE_BASE,
        ...props
    };
};

export const notify = (notifications = []) => {
    return {
        type: NOTIFY,
        notifications
    };
};